import { assignNamespace } from "@gr-common/head/namespace-utils";
import { o_util } from "@gr-common/head/namespaces";
import { defineStore } from "@gr-common/head/nexus";
import { customAssignments, isOnexVariant, mapOnexVariant, withOnex } from "./mappers.js";
import { fetchOnexData, transformAndAssignOnexData } from "./fragment.js";

export * from "./mappers.js";

assignNamespace(o_util, "onex", {
  isOnexGroup: isOnexVariant,
  mapOnexGroup: mapOnexVariant,
  isOnexVariant,
  mapOnexVariant,
  withOnex,
  customAssignments,
});

otto.onex.assignNamespace(
  { assignments: defineStore(transformAndAssignOnexData()) },
  { lock: import.meta.env.VITE_OTTO_IS_TESTING_BUNDLE !== "true" },
);

/*                                                                  */
if (import.meta.env.VITE_OTTO_IS_TESTING_BUNDLE !== "true") fetchOnexData();
